//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { BookingPriceOverrideItem } from './BookingPriceOverrideItem';
import { WebsiteBlockSignupFormAdditionalFieldsDisplayItem } from './WebsiteBlockSignupFormAdditionalFieldsDisplayItem';
import { WebsiteCustomFieldSignupFormDisplayItem } from './WebsiteCustomFieldSignupFormDisplayItem';
import { WebsiteBlockDisplayItem } from './WebsiteBlockDisplayItem';
import { StudentStatus, StudentTypes, SignupPaymentType, WebsiteBlockSignupFormType, WebsiteBlockType } from './Enums';

export class WebsiteBlockSignupFormDisplayItem extends WebsiteBlockDisplayItem {
    Header: string | null = null;
    DefaultStudentStatus: StudentStatus = StudentStatus.Active;
    AllowedStudentTypes: StudentTypes = StudentTypes.ChildOnly;
    TagIDs: string[] = [];
    TeacherIDs: string[] = [];
    EventCategoryIDs: string[] = [];
    PaymentType: SignupPaymentType | null = null;
    RegistrationFeeDescription: string | null = null;
    RegistrationFeeAmount: number | null = null;
    RegistrationFeeChargeCategoryID: string | null = null;
    DepositAmount: number | null = null;
    HoldTimeSlot: boolean = false;
    BookingPriceOverride: BookingPriceOverrideItem | null = null;
    SendLoginInformation: boolean = false;
    SendConfirmationEmail: boolean = false;
    EmailSubjectTemplate: string | null = null;
    EmailBodyTemplate: string | null = null;
    ThankYouMessage: string | null = null;
    SignupFormType: WebsiteBlockSignupFormType = WebsiteBlockSignupFormType.Default;
    override readonly WebsiteBlockType: WebsiteBlockType = WebsiteBlockType.SignupForm;
    AdditionalFields: WebsiteBlockSignupFormAdditionalFieldsDisplayItem | null = null;
    CustomFields: WebsiteCustomFieldSignupFormDisplayItem[] = [];

    constructor(initializer?: Partial<Omit<WebsiteBlockSignupFormDisplayItem, "WebsiteBlockType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "WebsiteBlockSignupFormDisplayItem";
}
